.PinkBaseButton {
  border: 1px solid transparent;
  background: transparent;
  font: var(--font-caption-lg-medium);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 7px 24px;
  transition: all .3s ease;
  border-radius: 18px;
  cursor: pointer;
  height: 32px;
  color: var(--semantic-colors-typography-inverse);

  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }

  &_isPrimary {
    background-color: var(--primitives-colors-brand-secondary);
    border-color: var(--primitives-colors-brand-secondary);

    &:hover {
      background-color: var(--primitives-colors-brand-secondary);
    }

    &:active {
      background-color: var(--primitives-colors-brand-secondary);
    }
  }

  &_isSecondary {
    border-color: var(--primitives-colors-brand-secondary);
    color: var(--primitives-colors-neutral-0);

    &:hover {
      background: var(--primitives-colors-brand-secondary);
      color: var(--semantic-colors-typography-inverse);
    }

    &:active {
      background: var(--primitives-colors-brand-secondary);
      color: var(--semantic-colors-typography-inverse);
    }
  }

  &_isSelected {
    border-color: var(--primitives-colors-brand-secondary);
    background: transparent;

    &:hover,
    &:active {
      background: transparent;
    }
  }
}
